export const logisticsTutorialSteps = [
      {
        target: '#logistics-hero',
        title: 'Centro operativo logístico',
        content: 'Este es el centro operativo. Desde acá armás la flota del día, organizás recorridos y seguís quién está listo para salir.',
        narration: 'Este es el centro operativo. Desde acá armás la flota del día, organizás recorridos y seguís quién está listo para salir.',
        audio: '/tutorials/logistica/01-centro-operativo.mp3',
        placement: 'bottom',
        disableBeacon: true,
      },
      {
        target: '#logistics-units-board',
        title: 'Tablero de unidades',
        content: 'Cada tarjeta representa una unidad operativa. Desde acá abrís su detalle, preparás rutas, compartís el acceso del chofer y revisás historial.',
        narration: 'Cada tarjeta representa una unidad operativa. Desde acá abrís su detalle, preparás rutas, compartís el acceso del chofer y revisás historial.',
        audio: '/tutorials/logistica/02-tablero-unidades.mp3',
        placement: 'top',
        disableBeacon: true,
      },
      {
        target: '#logistics-new-unit',
        title: 'Crear una nueva unidad',
        content: 'Desde acá das de alta una unidad nueva. La combinación de chofer y transporte queda lista para trabajar y después recibir rutas.',
        narration: 'Desde acá das de alta una unidad nueva. La combinación de chofer y transporte queda lista para trabajar y después recibir rutas.',
        audio: '/tutorials/logistica/03-nueva-unidad.mp3',
        placement: 'bottom',
        spotlightPadding: 8,
        disableBeacon: true,
      },
      {
        target: '#logistics-first-unit',
        title: 'Unidad de transporte',
        content: 'Esta es una unidad de trabajo. Acá ves rápido quién maneja, qué vehículo usa y si la unidad ya tiene algo en curso.',
        narration: 'Esta es una unidad de trabajo. Acá ves rápido quién maneja, qué vehículo usa y si la unidad ya tiene algo en curso.',
        audio: '/tutorials/logistica/03b-unidad-transporte-v2.mp3?v=4',
        placement: 'bottom',
        disableBeacon: true,
      },
      {
        target: '#logistics-first-unit-header',
        title: 'Cabecera de la unidad',
        content: 'La cabecera resume identidad, tipo y estado. Desde acá entrás a operar o plegás la tarjeta para mantener la vista limpia.',
        narration: 'La cabecera resume identidad, tipo y estado. Desde acá entrás a operar o plegás la tarjeta para mantener la vista limpia.',
        audio: '/tutorials/logistica/04-cabecera-unidad.mp3',
        placement: 'bottom',
        disableBeacon: true,
      },
      {
        target: '#logistics-first-unit-detail',
        title: 'Detalle de la unidad',
        content: 'En detalle revisás datos completos, foto, accesos y configuraciones de esa unidad para dejarla prolija antes de salir a la calle.',
        narration: 'En detalle revisás datos completos, foto, accesos y configuraciones de esa unidad para dejarla prolija antes de salir a la calle.',
        audio: '/tutorials/logistica/04b-detalle-unidad.mp3',
        placement: 'bottom',
        disableBeacon: true,
      },
      {
        target: '#logistics-first-unit-create',
        title: 'Crear ruta',
        content: 'Desde este acceso armás la hoja de ruta de la unidad. Ahí sumás servicios programados, pendientes o destinos manuales para dejar lista la salida.',
        narration: 'Desde este acceso armás la hoja de ruta de la unidad. Ahí sumás servicios programados, pendientes o destinos manuales para dejar lista la salida.',
        audio: '/tutorials/logistica/05-crear-ruta.mp3',
        placement: 'bottom',
        disableBeacon: true,
      },
      {
        target: '#logistics-first-unit-access',
        title: 'Acceso individual',
        content: 'Este link es el acceso del chofer desde el celular. Desde ahí ve su hoja, marca avances, sube evidencias y reporta el trabajo en tiempo real.',
        narration: 'Este link es el acceso del chofer desde el celular. Desde ahí ve su hoja, marca avances, sube evidencias y reporta el trabajo en tiempo real.',
        audio: '/tutorials/logistica/08-acceso-individual.mp3?v=2',
        placement: 'left',
        disableBeacon: true,
      },
      {
        target: '#logistics-first-unit-active',
        title: 'Ver ruta activa',
        content: 'Si la unidad ya está trabajando, desde acá abrís el seguimiento individual para ver el recorrido, las paradas y el avance real.',
        narration: 'Si la unidad ya está trabajando, desde acá abrís el seguimiento individual para ver el recorrido, las paradas y el avance real.',
        audio: '/tutorials/logistica/06-ruta-activa.mp3',
        placement: 'left',
        disableBeacon: true,
      },
      {
        target: '#logistics-first-unit-history',
        title: 'Ver historial',
        content: 'Acá abrís el historial de la unidad para revisar recorridos cerrados, costos y trabajo ya realizado sin salir del módulo.',
        narration: 'Acá abrís el historial de la unidad para revisar recorridos cerrados, costos y trabajo ya realizado sin salir del módulo.',
        audio: '/tutorials/logistica/07-historial-unidad.mp3',
        placement: 'left',
        disableBeacon: true,
      },
      {
        target: '#logistics-units-board',
        title: 'Siguiente paso',
        content: 'Desde este tablero administrás la base operativa completa. Ahora pasamos a crear una ruta para ver cómo se arma la salida diaria.',
        narration: 'Desde este tablero administrás la base operativa completa. Ahora pasamos a crear una ruta para ver cómo se arma la salida diaria.',
        audio: '/tutorials/logistica/05-crear-ruta.mp3?v=2',
        placement: 'top',
        disableBeacon: true,
      },
];

export default logisticsTutorialSteps;
